import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from './Header.jsx';
import Sidebar from './Sidebar.jsx';
import Footer from './Footer.jsx';
import './Layout.css';
import { getSlope as apiSlope } from '../services/slope.js';
import { getAlerts as apiAlerts } from '../services/alert.js';
import { getDevicesLocations as apiDevicesLocations } from '../services/device.js';

const Layout = () => {
    const [slopeData, setSlopeData] = useState([]);
    const [alertData, setAlertData] = useState([]);
    const [devicesLoc, setDevicesLoc] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        const handleChange = (event) => {
            setIsMobile(event.matches);
            if (!event.matches) {
                setIsSidebarOpen(false);
            }
        };

        setIsMobile(mediaQuery.matches);
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await apiSlope();
                if (!data) {
                    console.error('No slope data found');
                    return;
                }
                setSlopeData(data || []);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData(); // Fetch once on mount

        const interval = setInterval(fetchData, 60000); // Poll every 60s

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await apiAlerts();
                if (!data) {
                    console.error('No alert data found');
                    return;
                }
                setAlertData(data || []);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData(); // Fetch once on mount

        const interval = setInterval(fetchData, 60000); // Poll every 60s

        const handleRefresh = () => {
            fetchData();
        };
        window.addEventListener('alerts:refresh', handleRefresh);

        return () => {
            clearInterval(interval); // Cleanup on unmount
            window.removeEventListener('alerts:refresh', handleRefresh);
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await apiDevicesLocations();
                if (!data) {
                    console.error('No device location data found');
                    return;
                }
                setDevicesLoc(data || []);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData(); // Fetch once on mount

        const interval = setInterval(fetchData, 600000); // Poll every 600s

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
    const closeSidebar = () => setIsSidebarOpen(false);

    return (
        <div className="layout">
            <Sidebar
                slopeData={slopeData}
                alertData={alertData}
                isMobile={isMobile}
                isOpen={!isMobile || isSidebarOpen}
                onClose={closeSidebar}
            />
            <div className="layout__main-container">
                <Header
                    isMobile={isMobile}
                    isSidebarOpen={isSidebarOpen}
                    onToggleSidebar={toggleSidebar}
                />
                <main className="layout__main-content">
                    <Outlet context={{ slopeData, alertData, devicesLoc }} />
                </main>
                <Footer />
            </div>
        </div>
    );
};

export default Layout;
